import React from 'react'
import { Box } from '@material-ui/core'
import { CommentCardHeader } from './comment-card-header'
import { CommentCardBody } from './comment-card-body'
import { CommentCardFooter } from './comment-card-footer'
import { CommentCardAdd } from './comment-card-add'
import { CommentCardEdit } from './comment-card-edit'
import { useStyles } from './styles'

const CommentCard = ({ children, comment, getMap }) => {
    const classes = useStyles()

    return (
        <Box className={classes.detailsRow}>
            <Box className={classes.detailsNameColumn}></Box>
            <Box
                ref={node => {
                    const map = getMap()
                    if (node) {
                        map?.set(comment.id, node)
                    } else {
                        map?.delete(comment.id)
                    }
                }}
                className={`${classes.commentInfo} ${classes.commentCardWrapper}`}>
                {children}
            </Box>
        </Box>
    )
}

CommentCard.Header = CommentCardHeader
CommentCard.Body = CommentCardBody
CommentCard.Footer = CommentCardFooter
CommentCard.NewComment = CommentCardAdd
CommentCard.Edit = CommentCardEdit

export default CommentCard
